module.exports = __webpack_public_path__ + "static/IBM-bc41f341980336a91da1c6370bfcc4e5.svg";